import { createFileRoute } from "@tanstack/react-router";

import { ReportPage } from "@/features/clinical/ReportPage";

export const Route = createFileRoute("/_app/screenings/$screeningId_/report")({
  component: function ReportRoute() {
    const { screeningId } = Route.useParams();
    return <ReportPage screeningId={screeningId} />;
  },
});
